import React from "react";
import PropTypes from "prop-types";

import AddEmployees from "./AddEmployees";
import TableSkills from "./TableSkills";
import EmployeesMobileView from "./mobile/Employees";

const Employees = ({
  isAdmin,
  isEdit,
  defUsers,
  skills,
  employees,
  employeesSkills,
  inServiceUsers,
  onEmployeesAdded,
  onUpdateSkill,
  onCheckAll,
  onDelete,
  currentUser
}) => (
  <div className="well shadowDepth1 employees">
    <div className="visible-xs">
      <EmployeesMobileView
        isAdmin={isAdmin}
        defUsers={defUsers}
        skills={skills}
        employees={employees}
        employeesSkills={employeesSkills}
        inServiceUsers={inServiceUsers}
        onUpdateSkill={onUpdateSkill}
        onCheckAll={onCheckAll}
        currentUser={currentUser}
      />
    </div>

    <div className="hidden-xs">
      <h3 className="text-center">Employees</h3>

      {employees.length > 0 ? (
        <TableSkills
          isAdmin={isAdmin}
          isEdit={isEdit}
          skills={skills}
          employees={employees}
          employeesSkills={employeesSkills}
          inServiceUsers={inServiceUsers}
          onUpdateSkill={onUpdateSkill}
          onCheckAll={onCheckAll}
          onDelete={onDelete}
          currentUser={currentUser}
        />
      ) : null}

      {isAdmin ? (
        <AddEmployees
          selected={employees.map(e => e.id)}
          defUsers={defUsers}
          onAdded={onEmployeesAdded}
        />
      ) : null}
    </div>
  </div>
);

Employees.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  defUsers: PropTypes.array.isRequired,
  skills: PropTypes.arrayOf(PropTypes.any).isRequired,
  employees: PropTypes.array.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  inServiceUsers: PropTypes.array.isRequired,
  onEmployeesAdded: PropTypes.func.isRequired,
  onUpdateSkill: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default Employees;
